import { render, staticRenderFns } from "./santa.vue?vue&type=template&id=2537b36e&"
import script from "./santa.vue?vue&type=script&lang=js&"
export * from "./santa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports